class RecommendedProducts extends HTMLElement {
	constructor() {
		super();
		this.maxRecommended = this.dataset.maxReco || 10;
	}
	connectedCallback() {
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);
			this.init();
		};
		new IntersectionObserver(handleIntersection.bind(this), {
			rootMargin: "0px 0px 400px 0px",
		}).observe(this);
	}

	async init() {
		const productsIds = this.getProductsIds();
		if (productsIds && productsIds.length > 0) {
			const responses = await this.getResults(productsIds);
			if (responses.length > 0) {
				const limit = Math.round(
					this.maxRecommended / productsIds.length
				);
				this.parentElement
					.querySelector(".swiper-wrapper.fallback-collection")
					?.remove();
				this.closest(".cart-drawer-recommendations")
					?.querySelector(".recommendation_heading")
					?.classList.remove("hidden");
				for (let i = 0; i < limit; i++) {
					responses.forEach((response) => {
						var inserted = false;
						while (!inserted) {
							const element = response[i];
							if (element) {
								const prodId = parseInt(
									element?.querySelector("[data-product-id]")
										?.dataset.productId
								);
								if (prodId && !productsIds.includes(prodId)) {
									this.appendChild(element.cloneNode(true));
									productsIds.push(prodId);
									inserted = true;
								} else {
									response[i].parentNode.removeChild(
										response[i]
									);
								}
							} else {
								inserted = true;
							}
						}
					});
				}
			}
		} else {
			this.remove();
		}
	}

	getProductsIds() {
		const productData = JSON.parse(
			localStorage.getItem("recentlyViewedProduct")
		);
		if (productData) {
			const products = productData.reverse().slice(0, 5);
			const productsIds = products.map((product) => parseInt(product.id));
			return productsIds;
		}
		return false;
	}

	async getResults(ids) {
		const responses = [];
		for (let id of ids) {
			var url = this.dataset.url.replace("[product_id]", id);
			const response = await this.getRecommendations(url);
			responses.push(response);
		}
		return responses;
	}

	getRecommendations(url) {
		return fetch(url)
			.then((response) => response.text())
			.then((text) => {
				const html = document.createElement("div");
				html.innerHTML = text;
				const recommendations = html.querySelector(this.tagName);

				if (
					recommendations &&
					recommendations.innerHTML.trim().length
				) {
					return recommendations.children;
				}
			})
			.catch((e) => {
				console.error(e);
			});
	}
}

customElements.define("recommended-products", RecommendedProducts);

class RecommendedProductsJson extends RecommendedProducts {
	constructor() {
		super();
	}

	getProductsIds() {
		return JSON.parse(
			this.querySelector('[type="application/json"]').textContent
		);
	}
}

customElements.define("recommended-products-json", RecommendedProductsJson);

class ProductGallery extends HTMLElement {
	constructor() {
		super();
		this.sections = {};
		this.querySelectorAll(".swiper-slide").forEach((slide) => {
			this.sections[slide.dataset.media] = {
				offset: slide.offsetTop,
				media: slide.dataset.media,
			};
		});
		this.scrollHandler();
		window.addEventListener('scroll', this.scrollHandler.bind(this));
	}
	
	scrollHandler() {
		var i = 0;
		var scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
		for (i in this.sections) {
			if (this.sections[i].offset <= scrollPosition) {
				this.querySelector('.dot.is-active')?.classList.remove('is-active');
				this.querySelector(`.dot[data-media='${this.sections[i].media}']`)?.classList.add('is-active');
			}
		}

	}
}

customElements.define("product-gallery", ProductGallery);

class CardSwatches extends HTMLElement {
	constructor() {
		super();
		this.collection = document.querySelector('collection-fav');
	}

	swatchTemplate = (brandName, colorName, url, background) => `
		<a class='card_image_toggle color' aria-label="${brandName} ${colorName}" href='/products/${url}'>
			<span
				class='color_swatch'
				style="background: ${background}"
			>
			</span>
		</a>`;

	displaySwatchesUnsubscriber = undefined;
	
	connectedCallback() {
		this.displaySwatchesUnsubscriber = subscribe(PUB_SUB_EVENTS.collectionFetched, this.displaySwatches.bind(this));
	}

	disconnectedCallback() {
		if (this.displaySwatchesUnsubscriber) {
			this.displaySwatchesUnsubscriber();
		}
	}

	displaySwatches() {
		this.collection.data.forEach(product => {
			var data = product.node.metafields.map( (x) => x && x.value );
			if (this.dataset.brandName == data[0]) {
				const background = data[3] ? `url(${data[3]}&transform=resize=50x50)` : data[2];
				this.innerHTML += this.swatchTemplate(data[0], data[1], product.node.handle, background);
			}
		});
	}
}

customElements.define("card-swatches", CardSwatches);
